const legalInfos = {
    cashforce: {
        nome: 'Cashforce',
        razaoSocial: 'Cashforce Serviços de Tecnologia da Informação Ltda.',
        cnpj: '36.047.250/0001-24',
        telefone: '11 94173-9617',
        email: 'contato@cashforce.com.br',
        endereco: 'Rua Nazaré Paulista, 21, Vila Madalena São Paulo - SP'
    },
    trial: {
        nome: 'Vupt Cred Securitizadora S/A',
        razaoSocial: 'Vupt Cred Securitizadora S/A',
        cnpj: '51.099.457/0001-36',
        telefone: '48 99123-2121',
        email: 'contato@vuptcred.com.br',
        endereco: 'Av. Santos Dumont - São Luís, Criciúma - SC, 88804-342'
    },
    viainvest: {
        nome: 'Via Invest',
        razaoSocial: 'Via Invest Consultoria de Crédito e Cobrança Ltda',
        cnpj: '04.659.982/0001-89',
        telefone: '11 5555-2144',
        email: 'comercial@viainvest.com.br',
        endereco: 'Av. Paulista, 1106 Andar 18º Cj 181 Centro - São Paulo - S.P.'
    },
    netmoney: {
        nome: 'Netmoney',
        razaoSocial: 'Netmoney Securitizadora S/A',
        cnpj: '45.360.607/0001-10',
        telefone: '64 3432-8550',
        email: 'atendimento@netmoney.com.br',
        endereco: 'Rua Adoniro Martins de Andrade, 74 Andar 1º Centro - Itumbiara - GO'
    },
    m7: {
        nome: 'Multi7',
        razaoSocial: 'Multi7 Capital Consultoria Ltda',
        cnpj: '17.044.073/0001-88',
        telefone: '0800 591 0077',
        email: 'operacoes@multisete.com.br - dpo@multisete.com',
        endereco: 'Av. Santos Dumont, 2122 Aldeota - Fortaleza - CE'
    },
    intrabank: {
        nome: 'Intrabank',
        razaoSocial: 'Intrabank Asset Management Ltda',
        cnpj: '42.621.928/0001-33',
        telefone: '11 4673-3300',
        email: 'suporte@agenteintrabank.com.br',
        endereco: 'Av. Magalhães de Castro, N.º 4800 Cj 253 Torre 01 25º andar - Cidade Jardim - São Paulo - SP'
    },
    biz2bank: {
        nome: 'Biz2Bank',
        razaoSocial: 'Biz 2 Bank Conectando Empresas Ltda',
        cnpj: '54.553.584/0001-51',
        telefone: '21 9 9011-9722',
        email: 'contato@biz2bank.com.br',
        endereco: 'Av. Das Américas, 19005 Bl. 1 Salas 1106 e 1109 - Recreio dos Bandeirantes - Rio de Janeiro - R.J.'
    },
    iriom: {
        nome: 'IRIOM',
        razaoSocial: 'SIGA BAAS LTDA',
        cnpj: '48.893.000/0001-94',
        telefone: '0800 591 1244',
        email: 'suporte@iriom.com.br',
        endereco: 'Av. Dr. Meirelles, 49 Andar 2 Sl 4. A - Altos do Caxipó - Cuiabá - MT'
    },
    carbon: {
        nome: 'Carbon',
        razaoSocial: 'Carbon Capital Consultoria Ltda.',
        cnpj: '50.073.102/0001-05',
        telefone: '0800 300 4232',
        email: 'mesafornecedores@carboncapitalx.com.br',
        endereco: 'Calçada das Margaridas, 163 Sl 02 Alphaville - Barueri - S.P.'
    },
    fundomultisupermercados: {
        nome: 'BRR',
        razaoSocial: 'BRR Assessoria de Cobrança e Administração de Crédito Ltda',
        cnpj: '68.687.953/0001-03',
        telefone: '21 3824 8876',
        email: 'atendimentofornecedor@brrcredito.com.br',
        endereco: 'Rua Jardim Botânico, 518 Andar 2º - Jardim Botânico - Rio de Janeiro R.J.'
    },
    amb: {
        nome: 'AMB',
        razaoSocial: 'AMB FIDC',
        cnpj: '30.899.610/0001-30',
        telefone: '86 3025 1111',
        email: 'suporte@ambfidc.com.br',
        endereco: 'Rua Barroso, 522 Sl B Cep: 64000-130 Centro - Teresina - PI'
    },
    mgpay: {
        nome: 'MG PAY',
        razaoSocial: 'MG PAY',
        cnpj: '57.563.811/0001-18,',
        telefone: '11 2361-2122',
        email: 'contato@mgpayrecebiveis.com.br',
        endereco: 'Rua George Ohm, nº 230 - Sala 74 Bloco B - Cep 04576-020 - São Paulo - SP'
    },
    universo: {
        nome: 'Universo',
        razaoSocial: 'UNIVERSO FINTECH LTDA',
        cnpj: '60.210.429/0001-35',
        telefone: '0800 591 0077',
        email: 'operacoes@multisete.com.br - dpo@multisete.com',
        endereco: 'Av. Santos Dumont, 2122 Aldeota - Fortaleza - CE'
    },
    somma: {
        nome: 'Somma',
        razaoSocial: 'Somma Investimentos S.A',
        cnpj: '05.563.299/0001-06',
        telefone: '48 3037 1018',
        email: 'suporte.fidc@gruposomma.com.br',
        endereco: 'Rua Nirberto Haase N.º 100 - 1º andar - Bairro Santa Mônica – Florianópolis - SC'
    },
}

export default legalInfos